import React from "react";
import GeneralIcon from "../../assets/icons/admin-customer-icons/general-icon";
import ContactsIcon from "../../assets/icons/admin-customer-icons/contacts-icon";
import BankingIcon from "../../assets/icons/admin-customer-icons/banking-icon";
import PaymentIcon from "../../assets/icons/admin-customer-icons/payment-icon";
import AccountingIcon from "../../assets/icons/admin-customer-icons/accounting-icon";
import AddressIcon from "../../assets/icons/admin-customer-icons/address-icon";
import PatientIcon from "../../assets/icons/admin-customer-icons/patient-icon";
import FamilyIcon from "../../assets/icons/admin-customer-icons/family-icon";
import InsuranceIcon from "../../assets/icons/admin-customer-icons/insurance-icon";
import ContactBook from "../../assets/icons/contact-book";

function NavBar({ tabs, currentTab, setCurrentTab, generalCreated,isNotFirstTabAllowed=false }) {
  const icons = [
    <GeneralIcon />,
    <ContactBook />,
    <BankingIcon />,
    <PaymentIcon />,
    <AccountingIcon />,
    <AddressIcon />,
    <PatientIcon />,
    <FamilyIcon />,
    <InsuranceIcon />,
  ];
  const divBg = [
    "--customer-div-general-gb",
    "--customer-div-contacts-gb",
    "--customer-div-banking-gb",
    "--customer-div-payment-gb",
    "--customer-div-accounting-gb",
    "--customer-div-address-gb",
    "--customer-div-patient-gb",
    "--customer-div-family-gb",
    "--customer-div-insurance-gb",
  ];

  const labelFg = [
    "--customer-general-fg",
    "--customer-contacts-fg",
    "--customer-banking-fg",
    "--customer-payment-fg",
    "--customer-accounting-fg",
    "--customer-address-fg",
    "--customer-patient-fg",
    "--customer-family-fg",
    "--customer-insurance-fg",
  ];
  const borderColors = [
    "--customer-general-border-color", // General Info
    "--customer-contacts-border-color", // Contacts
    "--customer-banking-border-color", // Banking
    "--customer-payment-border-color", // Payment
    "--customer-accounting-border-color", // Accounting
    "--customer-address-border-color", // Address
    "--customer-patient-border-color", // Patient Info
    "--customer-family-border-color", // Family Info
    "--customer-insurance-border-color", // Insurance
  ];

  const iconBgFrom = [
    "--customer-icon-general-from-gb",
    "--customer-icon-contacts-from-gb",
    "--customer-icon-banking-from-gb",
    "--customer-icon-payment-from-gb",
    "--customer-icon-accounting-from-gb",
    "--customer-icon-address-from-gb",
    "--customer-icon-patient-from-gb",
    "--customer-icon-family-from-gb",
    "--customer-icon-insurance-from-gb",
  ];

  const iconBgTo = [
    "--customer-icon-general-to-gb",
    "--customer-icon-contacts-to-gb",
    "--customer-icon-banking-to-gb",
    "--customer-icon-payment-to-gb",
    "--customer-icon-accounting-to-gb",
    "--customer-icon-address-to-gb",
    "--customer-icon-patient-to-gb",
    "--customer-icon-family-to-gb",
    "--customer-icon-insurance-to-gb",
  ];

  return (
    <div className="z-[1000] bg-white sticky top-0 user-select-none">
      <div
        className="flex gap-0 w-full border border-[var(--customer-nav-border-color)] rounded-[var(--customer-section-border-radius)] overflow-x-auto scrollbar-hide"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {tabs.map((item, index) => (
          <div
            key={index}
            onClick={() => {
              if(currentTab !== item){
                if(isNotFirstTabAllowed){
                  if(item===tabs[0]){
                    if(!generalCreated){
                      setCurrentTab(item);
                    }
                  }else{
                    if(generalCreated){
                      setCurrentTab(item);
                    }
                  }
                }else{
                  if (currentTab !== "General") {
                  if (generalCreated) setCurrentTab(item);
                } else setCurrentTab(item);
                }
            }
            }}
            className={`flex gap-3 cursor-pointer p-8 items-center justify-center flex-1 ${
              currentTab === item ? "pt-5 pb-6" : "py-[22px]"
            }
          ${currentTab === item ? "border-b-4 border-blue-500" : ""}
          ${
            index === 0
              ? "rounded-l-[var(--customer-section-border-radius)]"
              : ""
          }
          ${
            index === tabs.length - 1
              ? "rounded-r-[var(--customer-section-border-radius)]"
              : ""
          }`}
            style={{
              backgroundColor:
                currentTab === item
                  ? `var(${divBg[index]})`
                  : `var(--customer-nav-bg)`,
              borderColor: `var(${borderColors[index]})`,
            }}
          >
            <div
              className={`p-2 bg-gradient-to-r rounded-lg border-gray-200 flex justify-center flex-shrink-0`}
              style={{
                minWidth: "32px",
                maxWidth: "auto",
                backgroundImage: `linear-gradient(to right, var(${iconBgFrom[index]}), var(${iconBgTo[index]}))`,
              }}
            >
              {icons[index]}
            </div>
            <label
              style={{
                color:
                  currentTab === item
                    ? `var(${labelFg[index]})`
                    : `var(--customer-nav-fg)`,
              }}
              className={`w-auto whitespace-nowrap text-[length:var(--customer-current-nav-fs)] flex-shrink-0 ${
                currentTab === item
                  ? " font-[var(--customer-current-nav-fw)]"
                  : "font-[var(--customer-nav-fw)]"
              }`}
            >
              {item}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
  // return (
  //   <div className="z-[1000] bg-white  sticky top-0">
  //     <div
  //       className=" flex gap-0 w-full border border-[var(--customer-nav-border-color)] rounded-[var(--customer-section-border-radius)] overflow-x-auto scrollbar-hide"
  //       style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
  //     >
  //       {tabs.map((item, index) => (
  //         <div
  //           key={index}
  //           onClick={() => {
  //             if (currentTab !== "General") {
  //               if (generalCreated) setCurrentTab(item);
  //             } else setCurrentTab(item);
  //           }}
  //           className={`flex gap-3 cursor-pointer p-8 items-center flex-shrink-0 ${
  //             currentTab === item ? "pt-5 pb-6" : "py-[22px]"
  //           }
  //    ${currentTab === item ? "border-b-4 border-blue-500" : ""}
  //    ${index === 0 ? "rounded-l-[var(--customer-section-border-radius)]" : ""}
  //    ${
  //      index === tabs.length - 1
  //        ? "rounded-r-[var(--customer-section-border-radius)]"
  //        : ""
  //    }`}
  //           style={{
  //             backgroundColor:
  //               currentTab === item
  //                 ? `var(${divBg[index]})`
  //                 : `var(--customer-nav-bg)`,
  //             borderColor: `var(${borderColors[index]})`,
  //           }}
  //         >
  //           <div
  //             className={`p-2 bg-gradient-to-r rounded-lg border-gray-200 flex justify-center flex-shrink-0`}
  //             style={{
  //               minWidth: "32px",
  //               // maxWidth: "auto",
  //               backgroundImage: `linear-gradient(to right, var(${iconBgFrom[index]}), var(${iconBgTo[index]}))`,
  //             }}
  //           >
  //             {icons[index]}
  //           </div>
  //           <label
  //             style={{
  //               color:
  //                 currentTab === item
  //                   ? `var(${labelFg[index]})`
  //                   : `var(--customer-nav-fg)`,
  //             }}
  //             className={`w-auto whitespace-nowrap text-[length:var(--customer-current-nav-fs)] flex-shrink-0 ${
  //               currentTab === item
  //                 ? " font-[var(--customer-current-nav-fw)]"
  //                 : "font-[var(--customer-nav-fw)]"
  //             }`}
  //           >
  //             {item}
  //           </label>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );
}

export default NavBar;
